module.exports = __webpack_public_path__ + "img/19.0845b3b1.png";